export const TABS = {
  BLOCKS: 0,
  METADATA: 1,
};
